// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"83b253b8af9dcfa7","9229":"727973242bb33abd"}[chunkId] + ".css";
};